import { Component, OnInit, OnDestroy } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

import { AuthProvider } from '../../providers/auth/auth';

import { PrivacyPage } from './../privacy/privacy';
import { TermsPage } from './../terms/terms';

@Component({
  selector: 'page-legal',
  templateUrl: 'legal.html'
})
export class LegalPage implements OnInit, OnDestroy {
  title = 'Legal';

  currentUser: any;
  currentUserSubscription: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private authProvider: AuthProvider
  ) {}

  ngOnInit() {
    this.authProvider.getFbUser().then(fbUser => {
      console.log(fbUser);
      this.currentUserSubscription = this.authProvider
        .getUserByUid(fbUser.uid)
        .subscribe(
          data => {
            console.log(data);
            this.currentUser = data;

            return data;
          },
          err => {
            console.log(err);
          }
        );
    });
  }

  ngOnDestroy() {
    if (this.currentUserSubscription) {
      this.currentUserSubscription.unsubscribe();
    }
  }

  openPage(page: string) {
    switch (page) {
      case 'privacy': {
        this.navCtrl.push(PrivacyPage);
        break;
      }
      case 'terms': {
        this.navCtrl.push(TermsPage, { regType: this.currentUser.regType });
        break;
      }
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad LegalPage');
  }
}



// WEBPACK FOOTER //
// ./src/pages/legal/legal.ts